package net.zagart.ai.core.feature.story

data class StoryChoice(
    val id: String,
    val text: String,
    val summary: String? = null
)
